var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.839 2.97816C14.9416 3.22567 14.8993 3.43697 14.7122 3.61204L10.2479 8.07635V14.7955C10.2479 15.049 10.1302 15.2271 9.89472 15.3297C9.81624 15.3599 9.74078 15.375 9.66833 15.375C9.50534 15.375 9.36951 15.3176 9.26084 15.2029L6.94266 12.8848C6.82796 12.7701 6.77061 12.6342 6.77061 12.4773V8.07635L2.3063 3.61204C2.11915 3.43697 2.07689 3.22567 2.17952 2.97816C2.28215 2.74272 2.46024 2.625 2.71379 2.625H14.3047C14.5582 2.625 14.7363 2.74272 14.839 2.97816Z",
    fill: "#737C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterDropdown);
export default __webpack_public_path__ + "static/media/icon-filter-dropdown.edaa09e79884802f591becc7edc76014.svg";
export { ForwardRef as ReactComponent };